$(() => {
  // 仕様が変わる可能性が出てきたので仮実装

  const labelOf = e => $(`label[for="${$(e).attr('id')}"]`);

  $('[data-run="job_preview"]').on('click', () => {
    const container = $('#preview-container').empty();
    $(
      [
        'label',
        'input',
        'textarea',
        'select',
        'h4',
        'h5',
        'h6',
        '.preview-label',
      ]
        .map(s => `form ${s}`)
        .join(',')
    ).each(function() {
      if (
        this instanceof HTMLInputElement ||
        this instanceof HTMLSelectElement ||
        this instanceof HTMLTextAreaElement
      ) {
        const value =
          (['text', 'number', 'datetime-local', 'email'].includes(this.type) &&
            !this.hidden) ||
          this instanceof HTMLTextAreaElement
            ? $(this).val()
            : this instanceof HTMLSelectElement
              ? $(this)
                  .find(':selected')
                  .text()
              : this.type === 'checkbox' && this.checked
                ? 'CHECKBOX'
                : this.type === 'file'
                  ? Array.from(this.files)
                      .map(f => f.name)
                      .join(', ')
                  : null;

        if (value !== null) {
          const label = labelOf(this);

          if (label.length) {
            const tag = value === 'CHECKBOX' ? '<span class="me-2">' : '<h6>';
            container.append($(tag).text(label.text()));
          }

          if (value !== 'CHECKBOX') {
            container.append(
              $('<div>')
                .addClass('mb-4')
                .text(value)
            );
          }
        }
      }

      if (this instanceof HTMLHeadingElement) {
        container.append($(`<${this.tagName}>`).text($(this).text()));
      }

      if ($(this).hasClass('preview-label')) {
        container.append($('<div>').text($(this).text()));
      }
    });
  });
});
